export default "__VITE_ASSET__YuL_NF0X__"